namespace advisorop.components.common {

    class SearchSecProductOrManagerController {

        onSecuritySymbolSelected: any;
        onValuesSelected: any;
        onValueSelected: any;
        onFullTextSearch: any;
        selectedValue: any;
        fullTextSearchValue: string;
        resetSearch: boolean;
        resetMultiselectSearch: boolean;

        boValuesList: Array<any> = [];
        returnList: Array<any> = [];

        searchManagers: boolean = false;
        searchProducts: boolean = false;
        searchSecurities: boolean = false;
        fullTextSearch: boolean = false;

        // for internal use
        searching = false;
        noResults = false;

        static $inject = ["managerApi"];
        constructor(
            private managerApi: services.ManagerApi
        ) {
        }

        $onInit(): void {
        };

        $routerOnActivate(next, previous) {
        };

        $onChanges(evt) {
            if (evt.resetSearch) {
                if (evt.resetSearch.currentValue == true && evt.resetSearch.previousValue == false) {
                    this.resetSecProdManagerSearch();
                    this.resetFullTextSearch()
                }
                this.resetMultiselectSearch = this.resetSearch;
            }
        }
        
        search(searchTerm: string): ng.IPromise<{}> {
            return this.managerApi.searchSecProductOrManager(searchTerm, this.searchManagers, this.searchProducts, this.searchSecurities).then((response) => {
                this.boValuesList = response.data;
                return response.data;
            });
        };

        onSelect(item, model, label, event): void {
            var value = {};
            angular.copy(this.selectedValue, value);
            if (this.selectedValue.type == domains.BoSearchResultType.Manager ||
                this.selectedValue.type == domains.BoSearchResultType.Product) {
                this.onValueSelected({ value });
            } else {
                this.onSecuritySymbolSelected({ value });
            }
        };

        onSearch(): void {
            this.onFullTextSearch({ searchTerm: this.fullTextSearchValue });
        }

        onSearchValues(): void {
            var values = angular.copy(this.returnList);
            this.onValuesSelected({ values: values });
        }

        resetFullTextSearch() {
            this.fullTextSearchValue = null;
            this.fullTextSearch = false;
        }

        resetSecProdManagerSearch() {
            this.searchManagers = false;
            this.searchProducts = false;
            this.searchSecurities = false;
            this.selectedValue = null;
            this.boValuesList = [];
        }

        onCheckboxChanged(fullTextChanged: boolean) {
            if (fullTextChanged) {
                if (this.fullTextSearch) {
                    this.resetSecProdManagerSearch();
                }
            } else {
                this.resetFullTextSearch();
                this.selectedValue = null;
            }
        }
    }



    class SearchSecProductOrManager implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                onSecuritySymbolSelected: "&",
                onValueSelected: "&",
                onValuesSelected: "&",
                onFullTextSearch: "&",
                resetSearch: "<"
            };
            this.controller = SearchSecProductOrManagerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/search-sec-product-or-manager.html';
        }
    }
    angular.module(Constants.APP).component("searchSecProductOrManager", new SearchSecProductOrManager());
    
}